// src/components/MenuPage.js
import React from 'react';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Import Link from React Router
// import Banners from './Banners';

const MenuPage = () => {
    return (
        <Container className="my-5">
            <Row className="justify-content-md-center">
                <Col md={8} lg={8}>
                    <Card>
                        <Card.Body>
                            <Card.Title className="text-center mb-4"> <h2>Calculadoras financieras</h2></Card.Title>
                            <div className="d-grid gap-3">
                                 <Link to="/calculadoras-financieras/aguinaldo">
                                    <Button variant="primary" size="lg" className="w-100">
                                        Cálculo de aguinaldo
                                    </Button>
                                </Link>                                                                 
                                <Link to="/calculadoras-financieras/indemnizacion">
                                    <Button variant="primary" size="lg" className="w-100">
                                        Cálculo de indemnización
                                    </Button>
                                </Link>
                                <Link to="/calculadoras-financieras/simulador-de-creditos">
                                    <Button size="lg" className="w-100">
                                        Simulador de créditos 
                                    </Button>
                                </Link>
                                <Link to="/calculadoras-financieras/calculo-salario">
                                    <Button size="lg" className="w-100">
                                        Descuentos de Salario
                                    </Button>
                                </Link>
                                <Link to="/calculadoras-financieras/presupuesto">
                                    <Button size="lg" className="w-100">
                                        Calcula tu presupuesto
                                    </Button>
                                </Link>                                                                                                     
{/*                                 <Link to="/form2">
                                    <Button size="lg" className="w-100">
                                        Ir al Formulario 2
                                    </Button>
                                </Link>
                                <Link to="/form3">
                                    <Button variant="info" size="lg" className="w-100">
                                        Ir al Formulario 3
                                    </Button>
                                </Link>    */}                             
                                {/* Add more links here if you add more forms/pages */}
                            </div>

                            
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
        
    );
};

export default MenuPage;